(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-video"] && !Shopify.designMode) return;
  try {
    class ProductCardVideoAutoplay {
    constructor(video) {
      this.video = video;
      this.card = video.closest('product-card') || video;
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.hasLoaded = false;
      this.isWaitingForVideo = false;
      this.activationToken = 0;

      this.onPointerEnter = this.onPointerEnter.bind(this);
      this.onPointerLeave = this.onPointerLeave.bind(this);
      this.onIntersect = this.onIntersect.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);

      this.setup();
    }

    setup() {
      this.card.addEventListener('pointerenter', this.onPointerEnter);
      this.card.addEventListener('pointerleave', this.onPointerLeave);
      this.mobileQuery.addEventListener('change', this.onMediaChange);
      this.setupObserver();
    }

    setupObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }

      if (!this.mobileQuery.matches || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(this.onIntersect, { threshold: [0, 0.35] });
      this.observer.observe(this.video);
    }

    onMediaChange() {
      this.setupObserver();
    }

    onPointerEnter() {
      if (this.mobileQuery.matches) return;

      this.play();
    }

    onPointerLeave() {
      if (this.mobileQuery.matches || !this.hasLoaded) return;

      this.showPoster();
    }

    onIntersect(entries) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.play();
        } else if (this.hasLoaded) {
          this.showPoster();
        }
      }
    }

    play() {
      if (this.isWaitingForVideo) return;

      if (!this.hasLoaded) {
        if (!this.video.showDeferredMedia) return;

        this.video.showDeferredMedia();
        this.hasLoaded = this.video.hasAttribute('data-media-loaded');
        this.activateWhenReady();
        return;
      }

      this.activateWhenReady();
    }

    showPoster() {
      this.video.pauseMedia?.();
      delete this.video.dataset.productCardVideoActive;
      this.isWaitingForVideo = false;
      this.activationToken += 1;

      const videoElement = this.video.querySelector('video');
      if (videoElement) {
        this.prepareVideoElement(videoElement);
        videoElement.currentTime = 0;
      }
    }

    activateWhenReady() {
      const token = this.activationToken + 1;
      this.activationToken = token;
      const videoElement = this.video.querySelector('video');

      if (!videoElement) {
        this.activate(token);
        return;
      }

      this.prepareVideoElement(videoElement);

      if (videoElement.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        this.activate(token);
        return;
      }

      this.isWaitingForVideo = true;
      videoElement.addEventListener(
        'canplay',
        () => {
          if (this.activationToken !== token) {
            this.isWaitingForVideo = false;
            return;
          }

          this.isWaitingForVideo = false;
          this.activate(token);
        },
        { once: true }
      );
    }

    activate(token) {
      if (this.activationToken !== token) return;

      this.video.dataset.productCardVideoActive = 'true';
      this.video.playMedia?.();
    }

    prepareVideoElement(videoElement) {
      videoElement.muted = true;
      videoElement.defaultMuted = true;
      videoElement.playsInline = true;
      videoElement.setAttribute('muted', '');
      videoElement.setAttribute('playsinline', '');
      videoElement.setAttribute('webkit-playsinline', '');
      videoElement.setAttribute('disablepictureinpicture', '');
      videoElement.controls = false;
      videoElement.removeAttribute('controls');
    }
  }

  const initProductCardVideos = () => {
    document.querySelectorAll('.product-card-video:not([data-product-card-video-ready])').forEach((video) => {
      video.dataset.productCardVideoReady = 'true';
      new ProductCardVideoAutoplay(video);
    });
  };

  if (customElements.get('deferred-media')) {
    initProductCardVideos();
  } else {
    customElements.whenDefined('deferred-media').then(initProductCardVideos);
  }

  document.addEventListener('shopify:section:load', initProductCardVideos);
  } catch(e) { console.error(e); }
})();

})();
